export interface KibbeType {
  id: string;
  name: string;
  nameRu: string;
  family: "Dramatic" | "Natural" | "Classic" | "Gamine" | "Romantic";
  dominantLine: string;
  shortDescription: string;
  fullDescription: string;
  bodyCharacteristics: string[];
  facialFeatures: string[];
  clothingRecommendations: {
    silhouettes: string[];
    fabrics: string[];
    patterns: string[];
    accessories: string[];
    avoid: string[];
  };
  celebrities: string[];
  essenceKeywords: string[];
}

export const kibbeTypes: KibbeType[] = [
  {
    id: "dramatic",
    name: "Dramatic",
    nameRu: "Драматик",
    family: "Dramatic",
    dominantLine: "Острые, вытянутые линии",
    shortDescription: "Яркая, скульптурная внешность с чёткими линиями и выраженной геометрией.",
    fullDescription: "Драматик — это воплощение структуры и силы. Ваша внешность характеризуется длинными, острыми линиями тела и лица. Вы производите впечатление высокой и стройной, даже если ваш рост средний. Ваша природная геометрия требует одежды, которая подчёркивает эту скульптурность, а не скрывает её.",
    bodyCharacteristics: [
      "Длинная вертикальная линия тела",
      "Узкие, чётко очерченные плечи",
      "Прямые, длинные руки и ноги",
      "Угловатое, стройное телосложение",
      "Минимальная округлость силуэта"
    ],
    facialFeatures: [
      "Острые, выразительные черты лица",
      "Высокие скулы с чёткой линией",
      "Прямой или с горбинкой нос",
      "Тонкие, чётко очерченные губы",
      "Миндалевидные или узкие глаза"
    ],
    clothingRecommendations: {
      silhouettes: ["Длинные прямые силуэты", "Колонна", "Чёткие геометрические формы", "Приталенные жакеты"],
      fabrics: ["Плотные, структурные ткани", "Кожа", "Шёлк", "Тафта", "Креп"],
      patterns: ["Геометрические принты", "Вертикальные полосы", "Крупные абстракции", "Монохром"],
      accessories: ["Крупные минималистичные украшения", "Острые каблуки", "Структурные сумки", "Длинные серьги"],
      avoid: ["Мелкие рюши", "Цветочные принты", "Мягкие драпировки", "Укороченные силуэты"]
    },
    celebrities: ["Тильда Суинтон", "Кейт Бланшетт", "Джейми Ли Кёртис"],
    essenceKeywords: ["Скульптурность", "Драма", "Элегантность", "Мощь"]
  },
  {
    id: "soft-dramatic",
    name: "Soft Dramatic",
    nameRu: "Софт Драматик",
    family: "Dramatic",
    dominantLine: "Длинные линии с мягкими изгибами",
    shortDescription: "Величественная внешность, сочетающая драматичную структуру с женственными округлостями.",
    fullDescription: "Софт Драматик — это роскошь и величие. Ваша внешность соединяет длинные, выразительные линии Драматика с мягкими, округлыми формами. Вы производите впечатление «большой» и заметной — в самом лучшем смысле. Ваш стиль должен быть одновременно дерзким и женственным.",
    bodyCharacteristics: [
      "Выраженная вертикальная линия",
      "Широкие или заострённые плечи",
      "Пышные бёдра и/или грудь",
      "Тонкая талия при округлых формах",
      "Длинные руки и ноги"
    ],
    facialFeatures: [
      "Крупные, выразительные черты",
      "Полные губы",
      "Большие глаза с тяжёлыми веками",
      "Широкие скулы",
      "Сильная линия подбородка"
    ],
    clothingRecommendations: {
      silhouettes: ["Обволакивающие длинные платья", "Глубокие вырезы", "Приталенный верх с расклешённым низом"],
      fabrics: ["Тяжёлый шёлк", "Бархат", "Сатин", "Кашемир", "Джерси с плотностью"],
      patterns: ["Крупные цветы", "Леопард", "Крупная абстракция", "Тёмные тона"],
      accessories: ["Крупные серьги", "Массивные браслеты", "Роскошные клатчи", "Высокие каблуки"],
      avoid: ["Мелкие детали", "Укороченные модели", "Прямые мешковатые силуэты", "Скромные вырезы"]
    },
    celebrities: ["Софи Лорен", "Моника Белуччи", "Бейонсе"],
    essenceKeywords: ["Роскошь", "Величие", "Драма", "Чувственность"]
  },
  {
    id: "flamboyant-natural",
    name: "Flamboyant Natural",
    nameRu: "Фламбоянт Нэчурал",
    family: "Natural",
    dominantLine: "Широкие, свободные линии",
    shortDescription: "Свободная, атлетичная внешность с широким костяком и природной раскованностью.",
    fullDescription: "Фламбоянт Нэчурал — это природная свобода и размах. Ваше телосложение создаёт впечатление ширины и силы. Вы выглядите лучше всего в одежде, которая не стесняет движения и подчёркивает вашу естественную, непринуждённую красоту.",
    bodyCharacteristics: [
      "Широкий костяк, особенно плечи",
      "Умеренная вертикальная линия",
      "Длинные руки и ноги",
      "Притуплённые, широкие плечи",
      "Прямая линия бёдер"
    ],
    facialFeatures: [
      "Широкое лицо с мягкими чертами",
      "Крупный нос",
      "Широкие скулы",
      "Полные, но не пухлые губы",
      "Открытый, дружелюбный взгляд"
    ],
    clothingRecommendations: {
      silhouettes: ["Свободные, незаправленные силуэты", "Оверсайз", "Длинные кардиганы", "Широкие брюки"],
      fabrics: ["Натуральные ткани", "Лён", "Хлопок", "Замша", "Деним"],
      patterns: ["Природные мотивы", "Этно", "Крупная клетка", "Размытые принты"],
      accessories: ["Объёмные шарфы", "Кожаные ремни", "Сумки-тоут", "Ботинки на плоском ходу"],
      avoid: ["Обтягивающая одежда", "Строгие костюмы", "Мелкие детали", "Высокие тонкие каблуки"]
    },
    celebrities: ["Джулия Робертс", "Принцесса Диана", "Синди Кроуфорд"],
    essenceKeywords: ["Свобода", "Естественность", "Размах", "Сила"]
  },
  {
    id: "natural",
    name: "Natural",
    nameRu: "Нэчурал",
    family: "Natural",
    dominantLine: "Прямые, умеренно широкие линии",
    shortDescription: "Непринуждённая, гармоничная внешность с ровными пропорциями.",
    fullDescription: "Нэчурал — это баланс и естественная простота. Ваша внешность не кричит, а шепчет — и в этом её сила. Вы выглядите гармонично в одежде, которая выглядит так, будто вы просто накинули её, не задумываясь.",
    bodyCharacteristics: [
      "Средний костяк с лёгкой шириной",
      "Умеренные пропорции",
      "Слегка угловатые плечи",
      "Ровная линия талии",
      "Средняя длина рук и ног"
    ],
    facialFeatures: [
      "Ровные, умеренные черты",
      "Прямой нос",
      "Средние губы",
      "Некрупные, но выразительные глаза",
      "Притуплённая линия челюсти"
    ],
    clothingRecommendations: {
      silhouettes: ["Расслабленные прямые силуэты", "Рубашки навыпуск", "Миди-юбки", "Чиносы"],
      fabrics: ["Хлопок", "Шерсть", "Деним", "Трикотаж средней плотности"],
      patterns: ["Нейтральные тона", "Мягкая клетка", "Природные оттенки"],
      accessories: ["Минималистичные часы", "Кожаные сандалии", "Холщовые сумки"],
      avoid: ["Слишком нарядная одежда", "Избыток деталей", "Блёстки и стразы"]
    },
    celebrities: ["Дженнифер Энистон", "Камерон Диас"],
    essenceKeywords: ["Простота", "Гармония", "Естественность"]
  },
  {
    id: "soft-natural",
    name: "Soft Natural",
    nameRu: "Софт Нэчурал",
    family: "Natural",
    dominantLine: "Мягкие, слегка широкие линии",
    shortDescription: "Мягкая, округлая внешность с природной ширококостностью и женственными изгибами.",
    fullDescription: "Софт Нэчурал — это мягкая сила. Вы сочетаете ширину костяка Нэчурала с округлостью и мягкостью. Ваша красота — в непринуждённости и уюте. Одежда должна быть мягкой, свободной, но при этом подчёркивать ваши формы.",
    bodyCharacteristics: [
      "Умеренно широкий костяк",
      "Округлые бёдра и грудь",
      "Выраженная талия",
      "Мягкие, покатые плечи",
      "Средние конечности"
    ],
    facialFeatures: [
      "Мягкие, округлые черты",
      "Полные щёки",
      "Курносый или мягкий нос",
      "Пухлые губы",
      "Тёплый, добрый взгляд"
    ],
    clothingRecommendations: {
      silhouettes: ["Мягкие драпировки", "Запахи", "Расклешённые юбки", "Свободные блузы"],
      fabrics: ["Мягкая шерсть", "Хлопковый трикотаж", "Шифон", "Мягкий деним"],
      patterns: ["Акварельные принты", "Мелкий цветок", "Пастельные тона"],
      accessories: ["Мягкие шарфы", "Плетёные сумки", "Босоножки на платформе"],
      avoid: ["Жёсткие структурные формы", "Строгие линии", "Тёмный минимализм"]
    },
    celebrities: ["Скарлетт Йоханссон", "Шакира", "Дженнифер Лопес"],
    essenceKeywords: ["Мягкость", "Уют", "Женственность", "Естественность"]
  },
  {
    id: "dramatic-classic",
    name: "Dramatic Classic",
    nameRu: "Драматик Классик",
    family: "Classic",
    dominantLine: "Сбалансированные линии с лёгкой остротой",
    shortDescription: "Элегантная, сбалансированная внешность с нотками драматизма и остроты.",
    fullDescription: "Драматик Классик — это утончённая элегантность с характером. Ваши пропорции сбалансированы, но в них присутствует лёгкая острота и вытянутость. Вам идёт классическая одежда с драматичными акцентами.",
    bodyCharacteristics: [
      "Сбалансированные пропорции",
      "Слегка вытянутый силуэт",
      "Умеренно заострённые плечи",
      "Стройное телосложение",
      "Чётко очерченная талия"
    ],
    facialFeatures: [
      "Симметричные черты с остротой",
      "Выразительные скулы",
      "Прямой, аккуратный нос",
      "Тонкие, но чёткие губы",
      "Проницательный взгляд"
    ],
    clothingRecommendations: {
      silhouettes: ["Приталенные костюмы", "Платья-футляры", "Строгие блейзеры", "А-силуэт"],
      fabrics: ["Шерстяной креп", "Габардин", "Плотный шёлк", "Тонкая кожа"],
      patterns: ["Тонкая полоска", "Геометрия", "Монохром", "Контрастные сочетания"],
      accessories: ["Элегантные часы", "Структурные сумки", "Туфли-лодочки", "Тонкие ремни"],
      avoid: ["Оверсайз", "Слишком мягкие ткани", "Богемный стиль", "Спортивные элементы"]
    },
    celebrities: ["Жаклин Кеннеди", "Джордж Клуни"],
    essenceKeywords: ["Элегантность", "Утончённость", "Характер", "Сдержанность"]
  },
  {
    id: "classic",
    name: "Classic",
    nameRu: "Классик",
    family: "Classic",
    dominantLine: "Идеально сбалансированные линии",
    shortDescription: "Гармоничная, сбалансированная внешность с ровными пропорциями.",
    fullDescription: "Классик — это воплощение баланса. Ваша внешность — идеальные пропорции без перекосов в сторону остроты или мягкости. Вам подходит классическая одежда с чистыми линиями, ни больше, ни меньше.",
    bodyCharacteristics: [
      "Идеально сбалансированные пропорции",
      "Средний рост и костяк",
      "Умеренные плечи",
      "Плавная линия талии",
      "Пропорциональные конечности"
    ],
    facialFeatures: [
      "Симметричное лицо",
      "Ровные, гармоничные черты",
      "Умеренно полные губы",
      "Спокойный, уравновешенный взгляд",
      "Овальная форма лица"
    ],
    clothingRecommendations: {
      silhouettes: ["Полуприталенные силуэты", "Классические платья", "Прямые брюки", "Жакеты без излишеств"],
      fabrics: ["Шерсть", "Хлопок высокого качества", "Шёлк", "Кашемир"],
      patterns: ["Сдержанные принты", "Нейтральная палитра", "Тонкая клетка"],
      accessories: ["Жемчуг", "Классические часы", "Кожаные сумки", "Балетки"],
      avoid: ["Экстравагантные принты", "Рваный деним", "Неоновые цвета", "Слишком свободные силуэты"]
    },
    celebrities: ["Грейс Келли", "Кэтрин Миддлтон"],
    essenceKeywords: ["Баланс", "Гармония", "Классика", "Спокойствие"]
  },
  {
    id: "soft-classic",
    name: "Soft Classic",
    nameRu: "Софт Классик",
    family: "Classic",
    dominantLine: "Сбалансированные линии с мягкостью",
    shortDescription: "Мягкая, утончённая внешность с гармоничными округлыми линиями.",
    fullDescription: "Софт Классик — это нежная гармония. Ваши пропорции сбалансированы, но с лёгким уклоном в мягкость и округлость. Вам идёт элегантная, но не строгая одежда — с мягкими деталями и плавными линиями.",
    bodyCharacteristics: [
      "Сбалансированные, слегка округлые пропорции",
      "Мягкие, покатые плечи",
      "Плавная линия бёдер",
      "Средний рост",
      "Женственная фигура"
    ],
    facialFeatures: [
      "Мягкие, симметричные черты",
      "Слегка полные щёки",
      "Округлый нос",
      "Полные губы",
      "Мягкий, тёплый взгляд"
    ],
    clothingRecommendations: {
      silhouettes: ["Полуприталенные платья", "Мягкие блейзеры", "Юбки-карандаш", "Слегка расклешённые брюки"],
      fabrics: ["Мягкий кашемир", "Шёлк", "Тонкий трикотаж", "Хлопок"],
      patterns: ["Мелкий цветочный", "Пастельные тона", "Мягкие полоски"],
      accessories: ["Жемчуг", "Шёлковые шарфы", "Элегантные сумки", "Туфли на среднем каблуке"],
      avoid: ["Грубые ткани", "Агрессивные принты", "Тяжёлые ботинки", "Острые геометрические формы"]
    },
    celebrities: ["Мэрион Котийяр", "Мерил Стрип"],
    essenceKeywords: ["Нежность", "Гармония", "Мягкость", "Утончённость"]
  },
  {
    id: "flamboyant-gamine",
    name: "Flamboyant Gamine",
    nameRu: "Фламбоянт Гамин",
    family: "Gamine",
    dominantLine: "Острые, компактные линии",
    shortDescription: "Живая, дерзкая внешность с миниатюрным костяком и яркой энергией.",
    fullDescription: "Фламбоянт Гамин — это искра и дерзость. Вы компактны, но полны энергии. Ваша внешность сочетает острые черты с миниатюрным телосложением, создавая эффект яркой, запоминающейся индивидуальности.",
    bodyCharacteristics: [
      "Компактное, миниатюрное тело",
      "Острые, заострённые плечи",
      "Прямой силуэт без округлостей",
      "Короткие или средние конечности",
      "Стройная, мальчишеская фигура"
    ],
    facialFeatures: [
      "Острые, выразительные черты",
      "Большие глаза",
      "Заострённый подбородок",
      "Тонкие, чёткие губы",
      "«Эльфийское» выражение лица"
    ],
    clothingRecommendations: {
      silhouettes: ["Укороченные жакеты", "Мини-юбки", "Узкие брюки", "Чёткие геометрические формы"],
      fabrics: ["Плотный хлопок", "Деним", "Кожа", "Синтетика"],
      patterns: ["Полоска", "Горох", "Контрастные цветовые блоки", "Графика"],
      accessories: ["Яркие серьги", "Ремни", "Кеды или ботинки", "Мини-сумки"],
      avoid: ["Длинные расклешённые юбки", "Оверсайз", "Мягкие драпировки", "Романтические рюши"]
    },
    celebrities: ["Одри Хепбёрн", "Лайза Миннелли"],
    essenceKeywords: ["Дерзость", "Энергия", "Яркость", "Задор"]
  },
  {
    id: "gamine",
    name: "Gamine",
    nameRu: "Гамин",
    family: "Gamine",
    dominantLine: "Компактные, чёткие линии",
    shortDescription: "Миниатюрная, задорная внешность с сочетанием острых и мягких элементов.",
    fullDescription: "Гамин — это очарование контрастов. Вы миниатюрны, и ваша внешность играет на сочетании «мальчишеского» и «девичьего». В вас одновременно есть дерзость и нежность, и этот контраст — ваша главная сила.",
    bodyCharacteristics: [
      "Миниатюрный костяк",
      "Компактный силуэт",
      "Узкие плечи и бёдра",
      "Ровная линия тела",
      "Короткие конечности"
    ],
    facialFeatures: [
      "Смесь острых и мягких черт",
      "Большие, выразительные глаза",
      "Миниатюрный нос",
      "Небольшой рот",
      "Детское выражение лица"
    ],
    clothingRecommendations: {
      silhouettes: ["Укороченные модели", "Обтягивающие силуэты", "Шорты", "Мини"],
      fabrics: ["Хлопок", "Деним", "Лёгкий трикотаж"],
      patterns: ["Полоска", "Горох", "Контрастные цвета", "Мелкий принт"],
      accessories: ["Небольшие серьги", "Тонкие ремни", "Кеды", "Мини-сумки"],
      avoid: ["Длинные свободные юбки", "Тяжёлые ткани", "Массивные украшения"]
    },
    celebrities: ["Твигги", "Мия Фэрроу"],
    essenceKeywords: ["Задор", "Контраст", "Молодость", "Живость"]
  },
  {
    id: "soft-gamine",
    name: "Soft Gamine",
    nameRu: "Софт Гамин",
    family: "Gamine",
    dominantLine: "Компактные линии с мягкими изгибами",
    shortDescription: "Кукольная, миниатюрная внешность с округлыми женственными чертами.",
    fullDescription: "Софт Гамин — это кукольное очарование. Вы миниатюрны, как все Гамины, но при этом обладаете мягкостью и округлостью. Ваша внешность — это сочетание детской непосредственности и женственности.",
    bodyCharacteristics: [
      "Миниатюрный костяк",
      "Округлые формы при компактном теле",
      "Мягкие плечи",
      "Выраженная грудь и бёдра",
      "Короткая талия"
    ],
    facialFeatures: [
      "Округлые, кукольные черты",
      "Большие круглые глаза",
      "Пухлые щёки",
      "Полные губы",
      "Маленький круглый нос"
    ],
    clothingRecommendations: {
      silhouettes: ["Приталенные мини-платья", "Укороченные блузы", "Юбки-колокол", "Укороченные жакеты"],
      fabrics: ["Мягкий хлопок", "Шёлк", "Лёгкий трикотаж", "Тюль"],
      patterns: ["Мелкий цветок", "Горох", "Пастельные тона", "Принт а-ля Dior"],
      accessories: ["Ленты", "Бантики", "Маленькие серьги", "Сумки с фермуаром"],
      avoid: ["Длинные свободные силуэты", "Грубые ткани", "Минимализм без деталей"]
    },
    celebrities: ["Дрю Бэрримор", "Риз Уизерспун"],
    essenceKeywords: ["Кукольность", "Нежность", "Задор", "Женственность"]
  },
  {
    id: "theatrical-romantic",
    name: "Theatrical Romantic",
    nameRu: "Театральный Романтик",
    family: "Romantic",
    dominantLine: "Округлые линии с лёгкой остротой",
    shortDescription: "Роскошная, чувственная внешность с драматическим подтекстом.",
    fullDescription: "Театральный Романтик — это драма чувств. Ваша внешность сочетает романтическую округлость с нотками остроты и драматизма. Вы — воплощение роковой женственности, и ваш стиль должен быть столь же выразительным.",
    bodyCharacteristics: [
      "Миниатюрный костяк с пышными формами",
      "Песочные часы с заострёнными плечами",
      "Тонкая талия",
      "Пышная грудь и бёдра",
      "Короткие конечности"
    ],
    facialFeatures: [
      "Полные, чувственные черты",
      "Слегка заострённый нос или подбородок",
      "Большие, томные глаза",
      "Пухлые губы",
      "Высокие скулы"
    ],
    clothingRecommendations: {
      silhouettes: ["Приталенные платья", "Корсеты", "Юбки с высокой талией", "Облегающий верх"],
      fabrics: ["Кружево", "Бархат", "Шёлк", "Атлас"],
      patterns: ["Кружевные вставки", "Тёмные цветочные", "Леопард", "Бордо и чёрный"],
      accessories: ["Крупные серьги-капли", "Чокеры", "Вечерние клатчи", "Шпильки"],
      avoid: ["Спортивный стиль", "Прямые мешковатые силуэты", "Грубые ткани", "Минимализм"]
    },
    celebrities: ["Вивьен Ли", "Мила Кунис", "Селена Гомес"],
    essenceKeywords: ["Чувственность", "Драма", "Роскошь", "Страсть"]
  },
  {
    id: "romantic",
    name: "Romantic",
    nameRu: "Романтик",
    family: "Romantic",
    dominantLine: "Мягкие, округлые линии",
    shortDescription: "Мягкая, чувственная внешность с плавными округлыми формами и женственным силуэтом.",
    fullDescription: "Романтик — это воплощение мягкости и женственности. Ваша внешность — сплошные округлости и плавные линии. В вас нет ни одного острого угла — и в этом ваша уникальная красота. Ваш стиль должен быть мягким, женственным и роскошным.",
    bodyCharacteristics: [
      "Округлое, мягкое телосложение",
      "Пышные формы — грудь, бёдра",
      "Тонкая талия",
      "Покатые мягкие плечи",
      "Короткие, мягкие конечности"
    ],
    facialFeatures: [
      "Округлое, мягкое лицо",
      "Полные губы",
      "Большие, круглые глаза",
      "Пухлые щёки",
      "Мягкий, маленький нос"
    ],
    clothingRecommendations: {
      silhouettes: ["Приталенные, женственные платья", "Запахи", "Юбки-тюльпан", "Мягкие блузы"],
      fabrics: ["Шёлк", "Шифон", "Кружево", "Бархат", "Мягкий трикотаж"],
      patterns: ["Цветочные принты", "Акварельные разводы", "Пастельные тона", "Розовый и кремовый"],
      accessories: ["Жемчуг", "Серьги-капли", "Маленькие сумки", "Туфли с открытым носом"],
      avoid: ["Геометрические формы", "Жёсткие структурные ткани", "Спортивный стиль", "Минимализм"]
    },
    celebrities: ["Мэрилин Монро", "Кейт Уинслет", "Кристина Хендрикс"],
    essenceKeywords: ["Мягкость", "Женственность", "Чувственность", "Романтика"]
  }
];

export interface YinYangBalance {
  skeleton: number;   // -5 (yin) to +5 (yang)
  flesh: number;
  features: number;
  overall: number;
}

export interface AnalysisResult {
  id: string;
  date: string;
  photoDataUrls: string[];
  kibbeType: KibbeType;
  confidence: number;
  gender: "female" | "male";
  genderRu: string;
  personName?: string;
  detectedFeatures: {
    category: string;
    feature: string;
    value: string;
  }[];
  whyThisType: string[];
  yinYangBalance: YinYangBalance;
}

const mockFeatureSets: Record<string, {
  detectedFeatures: AnalysisResult["detectedFeatures"];
  whyThisType: string[];
  yinYangBalance: YinYangBalance;
  confidence: number;
}> = {
  "soft-dramatic": {
    confidence: 87,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Длинная" },
      { category: "Плечи", feature: "Ширина и форма", value: "Широкие, слегка заострённые" },
      { category: "Талия", feature: "Выраженность", value: "Ярко выражена" },
      { category: "Бёдра", feature: "Форма", value: "Округлые, пышные" },
      { category: "Лицо", feature: "Общая форма", value: "Овальное с выраженными скулами" },
      { category: "Губы", feature: "Полнота", value: "Полные, чувственные" },
      { category: "Глаза", feature: "Форма", value: "Большие, миндалевидные" },
      { category: "Нос", feature: "Форма", value: "Прямой, средний" },
    ],
    whyThisType: [
      "Выраженная вертикальная линия тела указывает на Драматическую группу",
      "Пышные формы бёдер и груди при тонкой талии добавляют мягкость — характерно для «софт» вариации",
      "Крупные, чувственные черты лица — полные губы, большие глаза — усиливают романтическую составляющую",
      "Широкие, слегка заострённые плечи создают баланс между структурой и мягкостью",
      "Общее впечатление — величественность с женственностью, что является визитной карточкой Софт Драматика"
    ],
    yinYangBalance: { skeleton: 3, flesh: -2, features: -1, overall: 1 },
  },
  "dramatic": {
    confidence: 89,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Длинная, вытянутая" },
      { category: "Плечи", feature: "Ширина и форма", value: "Узкие, острые" },
      { category: "Талия", feature: "Выраженность", value: "Прямая, не выражена" },
      { category: "Бёдра", feature: "Форма", value: "Узкие, прямые" },
      { category: "Лицо", feature: "Общая форма", value: "Вытянутое, угловатое" },
      { category: "Губы", feature: "Полнота", value: "Тонкие, чётко очерченные" },
      { category: "Глаза", feature: "Форма", value: "Миндалевидные, узкие" },
      { category: "Нос", feature: "Форма", value: "Прямой, заострённый" },
    ],
    whyThisType: [
      "Выраженная длинная вертикальная линия тела — главный маркер Драматика",
      "Угловатые, острые черты лица без округлостей подтверждают ян-доминанту",
      "Узкий, прямой силуэт без выраженных изгибов характерен для чистого Драматика",
      "Общее впечатление скульптурности и геометрии — визитная карточка типажа",
    ],
    yinYangBalance: { skeleton: 4, flesh: 3, features: 3, overall: 4 },
  },
  "flamboyant-natural": {
    confidence: 84,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Умеренно длинная" },
      { category: "Плечи", feature: "Ширина и форма", value: "Широкие, притуплённые" },
      { category: "Талия", feature: "Выраженность", value: "Не выражена, прямая" },
      { category: "Бёдра", feature: "Форма", value: "Прямые, широкие" },
      { category: "Лицо", feature: "Общая форма", value: "Широкое, открытое" },
      { category: "Губы", feature: "Полнота", value: "Умеренно полные" },
      { category: "Глаза", feature: "Форма", value: "Открытые, дружелюбные" },
      { category: "Нос", feature: "Форма", value: "Крупный, широкий" },
    ],
    whyThisType: [
      "Широкий костяк и притуплённые плечи — ключевой признак семейства Natural",
      "Умеренная вертикальная линия с акцентом на ширину характерна для Flamboyant Natural",
      "Открытые, крупные черты лица без острых углов подтверждают классификацию",
      "Прямой силуэт без выраженной талии — типичный маркер данного типажа",
    ],
    yinYangBalance: { skeleton: 3, flesh: 1, features: 1, overall: 2 },
  },
  "natural": {
    confidence: 81,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Средняя" },
      { category: "Плечи", feature: "Ширина и форма", value: "Слегка широкие, притуплённые" },
      { category: "Талия", feature: "Выраженность", value: "Ровная" },
      { category: "Бёдра", feature: "Форма", value: "Прямые, умеренные" },
      { category: "Лицо", feature: "Общая форма", value: "Ровное, умеренное" },
      { category: "Губы", feature: "Полнота", value: "Средние" },
      { category: "Глаза", feature: "Форма", value: "Спокойные, некрупные" },
      { category: "Нос", feature: "Форма", value: "Прямой, средний" },
    ],
    whyThisType: [
      "Умеренная ширина костяка без крайностей — базовый признак чистого Natural",
      "Ровные, гармоничные пропорции без перекосов в сторону остроты или мягкости",
      "Лицо с притуплёнными, естественными чертами соответствует профилю Natural",
      "Общее впечатление непринуждённости и гармонии — визитная карточка типажа",
    ],
    yinYangBalance: { skeleton: 2, flesh: 0, features: 0, overall: 1 },
  },
  "dramatic-classic": {
    confidence: 83,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Средняя с вытянутостью" },
      { category: "Плечи", feature: "Ширина и форма", value: "Умеренные, слегка заострённые" },
      { category: "Талия", feature: "Выраженность", value: "Чётко очерчена" },
      { category: "Бёдра", feature: "Форма", value: "Пропорциональные, ровные" },
      { category: "Лицо", feature: "Общая форма", value: "Симметричное, с острыми акцентами" },
      { category: "Губы", feature: "Полнота", value: "Тонкие, чёткие" },
      { category: "Глаза", feature: "Форма", value: "Проницательные, выразительные" },
      { category: "Нос", feature: "Форма", value: "Прямой, аккуратный" },
    ],
    whyThisType: [
      "Сбалансированные пропорции с лёгкой вытянутостью — базовый признак Dramatic Classic",
      "Симметричные черты лица с акцентами остроты характерны для данного типажа",
      "Классическая гармония с нотками драматизма в плечах и скулах",
      "Общее впечатление утончённой элегантности с характером",
    ],
    yinYangBalance: { skeleton: 2, flesh: 0, features: 1, overall: 1 },
  },
  "classic": {
    confidence: 80,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Средняя, идеально пропорциональная" },
      { category: "Плечи", feature: "Ширина и форма", value: "Умеренные, ровные" },
      { category: "Талия", feature: "Выраженность", value: "Плавная, умеренная" },
      { category: "Бёдра", feature: "Форма", value: "Пропорциональные" },
      { category: "Лицо", feature: "Общая форма", value: "Симметричное, овальное" },
      { category: "Губы", feature: "Полнота", value: "Умеренно полные" },
      { category: "Глаза", feature: "Форма", value: "Спокойные, уравновешенные" },
      { category: "Нос", feature: "Форма", value: "Ровный, пропорциональный" },
    ],
    whyThisType: [
      "Идеально сбалансированные пропорции без перекосов — главный маркер чистого Classic",
      "Симметричное лицо с ровными чертами подтверждает классическую гармонию",
      "Отсутствие выраженных крайностей (ни острых, ни мягких) — визитная карточка типажа",
      "Общее впечатление спокойной, уравновешенной красоты",
    ],
    yinYangBalance: { skeleton: 0, flesh: 0, features: 0, overall: 0 },
  },
  "soft-classic": {
    confidence: 82,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Средняя" },
      { category: "Плечи", feature: "Ширина и форма", value: "Мягкие, покатые" },
      { category: "Талия", feature: "Выраженность", value: "Плавно выражена" },
      { category: "Бёдра", feature: "Форма", value: "Слегка округлые" },
      { category: "Лицо", feature: "Общая форма", value: "Мягкое, симметричное" },
      { category: "Губы", feature: "Полнота", value: "Полные" },
      { category: "Глаза", feature: "Форма", value: "Мягкие, тёплые" },
      { category: "Нос", feature: "Форма", value: "Округлый, небольшой" },
    ],
    whyThisType: [
      "Сбалансированные пропорции с уклоном в мягкость — характерно для Soft Classic",
      "Покатые плечи и мягкие линии тела добавляют инь-составляющую к классической базе",
      "Округлые, нежные черты лица подтверждают «софт» вариацию Classic",
      "Общее впечатление элегантной мягкости и утончённости",
    ],
    yinYangBalance: { skeleton: 0, flesh: -1, features: -1, overall: -1 },
  },
  "flamboyant-gamine": {
    confidence: 86,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Короткая, компактная" },
      { category: "Плечи", feature: "Ширина и форма", value: "Острые, заострённые" },
      { category: "Талия", feature: "Выраженность", value: "Прямая, не выражена" },
      { category: "Бёдра", feature: "Форма", value: "Узкие, прямые" },
      { category: "Лицо", feature: "Общая форма", value: "Острое, выразительное" },
      { category: "Губы", feature: "Полнота", value: "Тонкие, чёткие" },
      { category: "Глаза", feature: "Форма", value: "Большие, широко расставленные" },
      { category: "Нос", feature: "Форма", value: "Заострённый, миниатюрный" },
    ],
    whyThisType: [
      "Компактное телосложение с острыми углами — ключевой признак Flamboyant Gamine",
      "Миниатюрный костяк с заострёнными плечами и чёткими линиями",
      "Выразительные, острые черты лица с «эльфийским» характером",
      "Общее впечатление дерзкой энергии и яркой индивидуальности",
    ],
    yinYangBalance: { skeleton: 3, flesh: 2, features: 1, overall: 2 },
  },
  "gamine": {
    confidence: 83,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Короткая" },
      { category: "Плечи", feature: "Ширина и форма", value: "Узкие, умеренные" },
      { category: "Талия", feature: "Выраженность", value: "Ровная" },
      { category: "Бёдра", feature: "Форма", value: "Узкие, компактные" },
      { category: "Лицо", feature: "Общая форма", value: "Смесь острых и округлых черт" },
      { category: "Губы", feature: "Полнота", value: "Небольшие" },
      { category: "Глаза", feature: "Форма", value: "Большие, выразительные" },
      { category: "Нос", feature: "Форма", value: "Миниатюрный" },
    ],
    whyThisType: [
      "Миниатюрный компактный силуэт — базовый маркер семейства Gamine",
      "Сочетание острых и мягких черт в лице создаёт контраст, характерный для чистого Gamine",
      "Большие глаза на маленьком лице усиливают «детское» впечатление типажа",
      "Общий баланс инь и ян без перекоса — визитная карточка чистого Gamine",
    ],
    yinYangBalance: { skeleton: 1, flesh: 0, features: -1, overall: 0 },
  },
  "soft-gamine": {
    confidence: 85,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Короткая, компактная" },
      { category: "Плечи", feature: "Ширина и форма", value: "Мягкие, покатые" },
      { category: "Талия", feature: "Выраженность", value: "Короткая, выражена" },
      { category: "Бёдра", feature: "Форма", value: "Округлые" },
      { category: "Лицо", feature: "Общая форма", value: "Округлое, кукольное" },
      { category: "Губы", feature: "Полнота", value: "Пухлые" },
      { category: "Глаза", feature: "Форма", value: "Большие, круглые" },
      { category: "Нос", feature: "Форма", value: "Маленький, курносый" },
    ],
    whyThisType: [
      "Миниатюрный костяк с округлыми формами — ключевой признак Soft Gamine",
      "Кукольные черты лица с пухлыми губами и большими глазами усиливают инь-составляющую",
      "Округлость при компактном теле создаёт «кукольный» эффект типажа",
      "Общее впечатление нежного задора и женственности",
    ],
    yinYangBalance: { skeleton: 1, flesh: -2, features: -2, overall: -1 },
  },
  "theatrical-romantic": {
    confidence: 86,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Короткая" },
      { category: "Плечи", feature: "Ширина и форма", value: "Заострённые при миниатюрном костяке" },
      { category: "Талия", feature: "Выраженность", value: "Тонкая, ярко выражена" },
      { category: "Бёдра", feature: "Форма", value: "Пышные, округлые" },
      { category: "Лицо", feature: "Общая форма", value: "Чувственное с острыми акцентами" },
      { category: "Губы", feature: "Полнота", value: "Пухлые, чувственные" },
      { category: "Глаза", feature: "Форма", value: "Большие, томные" },
      { category: "Нос", feature: "Форма", value: "Слегка заострённый" },
    ],
    whyThisType: [
      "Миниатюрный костяк с пышными формами — базовый признак романтической группы",
      "Заострённые плечи и нос добавляют «театральный» акцент к романтической основе",
      "Чувственные черты лица — полные губы, томные глаза — подтверждают доминанту инь",
      "Общее впечатление роковой женственности с драматическим подтекстом",
    ],
    yinYangBalance: { skeleton: 0, flesh: -3, features: -2, overall: -2 },
  },
  "romantic": {
    confidence: 88,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Короткая" },
      { category: "Плечи", feature: "Ширина и форма", value: "Покатые, мягкие" },
      { category: "Талия", feature: "Выраженность", value: "Тонкая, ярко выражена" },
      { category: "Бёдра", feature: "Форма", value: "Пышные, округлые" },
      { category: "Лицо", feature: "Общая форма", value: "Округлое, мягкое" },
      { category: "Губы", feature: "Полнота", value: "Полные, пухлые" },
      { category: "Глаза", feature: "Форма", value: "Большие, круглые" },
      { category: "Нос", feature: "Форма", value: "Мягкий, маленький" },
    ],
    whyThisType: [
      "Округлое телосложение с пышными формами — главный маркер чистого Romantic",
      "Мягкие, покатые плечи без острых углов подтверждают полную инь-доминанту",
      "Округлые, чувственные черты лица — полные губы, большие глаза, мягкий нос",
      "Общее впечатление абсолютной мягкости и женственности — визитная карточка типажа",
    ],
    yinYangBalance: { skeleton: -3, flesh: -4, features: -3, overall: -4 },
  },
  "default": {
    confidence: 82,
    detectedFeatures: [
      { category: "Рост", feature: "Вертикальная линия", value: "Средняя" },
      { category: "Плечи", feature: "Ширина и форма", value: "Умеренные, ровные" },
      { category: "Талия", feature: "Выраженность", value: "Умеренно выражена" },
      { category: "Бёдра", feature: "Форма", value: "Пропорциональные" },
      { category: "Лицо", feature: "Общая форма", value: "Овальное" },
      { category: "Губы", feature: "Полнота", value: "Средние" },
      { category: "Глаза", feature: "Форма", value: "Выразительные" },
      { category: "Нос", feature: "Форма", value: "Прямой" },
    ],
    whyThisType: [
      "Пропорции тела указывают на данную группу типажей",
      "Характерные черты лица соответствуют этому типажу",
      "Баланс линий и форм подтверждает классификацию",
      "Общее впечатление от внешности совпадает с ключевыми характеристиками типажа",
    ],
    yinYangBalance: { skeleton: 1, flesh: -1, features: 0, overall: 0 },
  },
};

/**
 * Generates personalized reasoning for why a particular Kibbe type was determined,
 * referencing specific detected features from the photo analysis.
 * In production, this reasoning is generated by the AI/ML model.
 */
function generatePersonalizedReasons(
  type: KibbeType,
  features: AnalysisResult["detectedFeatures"],
  gender: "female" | "male"
): string[] {
  const reasons: string[] = [];
  const genderContext = gender === "female" ? "женской внешности" : "мужской внешности";

  const heightFeat = features.find(f => f.category === "Рост");
  if (heightFeat) {
    reasons.push(
      `${heightFeat.value} вертикальная линия вашей ${genderContext} характерна для группы «${type.family}» в системе Кибби`
    );
  }

  const shoulderFeat = features.find(f => f.category === "Плечи");
  if (shoulderFeat) {
    reasons.push(
      `Форма плеч — ${shoulderFeat.value.toLowerCase()} — соответствует ключевым характеристикам типажа ${type.nameRu}`
    );
  }

  const waistFeat = features.find(f => f.category === "Талия");
  const hipFeat = features.find(f => f.category === "Бёдра");
  if (waistFeat && hipFeat) {
    reasons.push(
      `Соотношение талии (${waistFeat.value.toLowerCase()}) и бёдер (${hipFeat.value.toLowerCase()}) формирует ${type.dominantLine.toLowerCase()}`
    );
  }

  const faceFeat = features.find(f => f.category === "Лицо");
  const lipFeat = features.find(f => f.category === "Губы");
  if (faceFeat && lipFeat) {
    reasons.push(
      `${faceFeat.value} форма лица в сочетании с ${lipFeat.value.toLowerCase()} губами усиливает принадлежность к данному типажу`
    );
  }

  reasons.push(
    `Общий баланс инь-ян вашей внешности совпадает с профилем типажа ${type.nameRu} — ${type.shortDescription.toLowerCase()}`
  );

  return reasons;
}

/**
 * Server-side analysis mock — simulates AI/ML photo analysis.
 *
 * Architecture:
 * 1. Client POSTs photos to /api/analyze
 * 2. Server receives photos and runs analysis (this function)
 * 3. In production: photos are sent to AI/ML API for feature detection & classification
 * 4. Server returns AnalysisResult to client
 *
 * This mock uses a deterministic hash of the photo data so the same photos
 * always yield the same type — simulating consistent AI/ML analysis.
 */
export function getMockAnalysisResult(photoDataUrls: string[]): AnalysisResult {
  // All 13 classic Kibbe types available for classification
  const typePool = [
    "dramatic",
    "soft-dramatic",
    "flamboyant-natural",
    "natural",
    "soft-natural",
    "dramatic-classic",
    "classic",
    "soft-classic",
    "flamboyant-gamine",
    "gamine",
    "soft-gamine",
    "theatrical-romantic",
    "romantic",
  ];

  // Deterministic selection: hash the photo data so the same photos always return the same type.
  // In production, photos are sent to an AI/ML vision API that detects facial features,
  // body proportions, bone structure, and flesh distribution to classify the Kibbe type.
  const seed = photoDataUrls.reduce((acc, url) => {
    let hash = acc;
    for (let i = 0; i < Math.min(url.length, 200); i += 7) {
      hash = ((hash << 5) - hash + url.charCodeAt(i)) | 0;
    }
    hash = ((hash << 5) - hash + url.length) | 0;
    return hash;
  }, 0);
  const selectedId = typePool[Math.abs(seed) % typePool.length];
  const type = kibbeTypes.find(t => t.id === selectedId)!;
  const featureSet = mockFeatureSets[selectedId] || mockFeatureSets["default"];

  // Gender detection — in production, determined by AI/ML API from photo analysis
  const genderBit = ((seed >>> 3) & 0x7) % 5;
  const gender = genderBit === 0 ? ("male" as const) : ("female" as const);
  const genderRu = gender === "female" ? "Женский" : "Мужской";

  // Mock person names — in production, user may optionally enter their name
  const femaleNames = ["Анна", "Мария", "Елена", "Ольга", "Наталья", "Екатерина", "Ирина", "Светлана", "Дарья", "Юлия", "Алиса", "Виктория", "Полина"];
  const maleNames = ["Александр", "Дмитрий", "Максим", "Артём", "Иван", "Андрей", "Михаил", "Николай", "Сергей"];
  const namePool = gender === "female" ? femaleNames : maleNames;
  const nameIndex = Math.abs((seed >>> 5) + seed) % namePool.length;
  const personName = namePool[nameIndex];

  return {
    id: crypto.randomUUID(),
    date: new Date().toISOString(),
    photoDataUrls,
    kibbeType: type,
    confidence: featureSet.confidence,
    gender,
    genderRu,
    personName,
    detectedFeatures: featureSet.detectedFeatures,
    whyThisType: generatePersonalizedReasons(type, featureSet.detectedFeatures, gender),
    yinYangBalance: featureSet.yinYangBalance,
  };
}

export function getAllKibbeTypes(): KibbeType[] {
  return kibbeTypes;
}

export function getKibbeTypeById(id: string): KibbeType | undefined {
  return kibbeTypes.find(t => t.id === id);
}
